<template>
	<div class="modal fade show" tabindex="-1" role="dialog" style="display: block; background: rgba(0, 0, 0, 0.5);">
		<div class="modal-dialog modal-fullscreen-sm-down" role="document">
			<div class="modal-content">
				<div class="modal-header bg-secondary text-white">
					<h5 class="modal-title">{{ idsBulk ? 'Associa ' + idsBulk.length + ' note spese a progetto' : 'Associa nota spesa a progetto' }}</h5>
					<button type="button" class="btn-close btn-close-white" @click="close()"></button>
				</div>

				<div class="modal-body">
					<!-- Dettagli nota (read-only) -->
					<div class="card mb-3 border-secondary" v-if="!idsBulk">
						<div class="card-body p-2">
							<div class="row g-2">
								<div class="col-3">
									<small class="text-muted d-block">Data</small>
									<div class="fw-500">{{ formatData(notaSpesa.DATA) }}</div>
								</div>
								<div class="col-3">
									<small class="text-muted d-block">Importo</small>
									<div :style="{ color: getImportoColor(notaSpesa) }" class="fw-bold">
										{{ getImportoSign(notaSpesa) }} € {{ formatImporto(notaSpesa.IMPORTO) }}
									</div>
								</div>
								<div class="col-6">
									<small class="text-muted d-block">Descrizione</small>
									<div>{{ notaSpesa.DESCRIZIONE }}</div>
								</div>
							</div>
						</div>
					</div>

					<!-- Form associazione -->
					<form @submit.prevent="saveAssociazione">
						<div class="mb-3">
							<label class="form-label">Progetto *</label>
							<select v-model="selectedProgetto" class="form-control" required :disabled="loadingProgetti">
								<option value="">Seleziona un progetto...</option>
								<option v-for="p in arrayProgetti" :key="p.ID_PROGETTO" :value="p.ID_PROGETTO">
									{{ filters.titoloConTipologia(p) }}
								</option>
							</select>
						</div>

						<div v-if="message" class="alert" :class="messageClass" role="alert">
							{{ message }}
						</div>

						<div class="modal-footer">
							<button type="button" class="btn btn-secondary" @click="close()">Annulla</button>
							<button type="submit" class="btn btn-primary" :disabled="loading || !selectedProgetto">
								<span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
								Associa al progetto
							</button>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ModalAssociaNotaSpesa',
	props: {
		notaSpesa: {
			type: Object,
			default: null
		},
		idsBulk: {
			type: Array,
			default: null
		}
	},
	emits: ['close', 'saved'],
	data() {
		return {
			filters: global.filters,
			selectedProgetto: '',
			arrayProgetti: [],
			loadingProgetti: false,
			loading: false,
			message: '',
			messageClass: ''
		};
	},
	watch: {
		notaSpesa: {
			immediate: true,
			handler(nota) {
				if (!nota) return;
				this.selectedProgetto = nota.FK_ID_PROGETTO || '';
				this.message = '';
				this.messageClass = '';
			}
		}
	},
	methods: {
		saveAssociazione() {
			if (!this.selectedProgetto) {
				this.message = 'Seleziona un progetto';
				this.messageClass = 'alert-warning';
				return;
			}

			this.loading = true;
			this.message = '';

			if (this.idsBulk) {
				utils.put('theb/note_spese/associa-progetto-bulk', { IDS: this.idsBulk, FK_ID_PROGETTO: this.selectedProgetto }, (res) => {
					this.loading = false;
					if (res.esito == 0) {
						this.$emit('saved');
						this.close();
					} else {
						this.message = res.messaggio || 'Errore nel salvataggio';
						this.messageClass = 'alert-danger';
					}
				});
				return;
			}

			const payload = {
				ID_NOTA_SPESA: this.notaSpesa.ID_NOTA_SPESA,
				FK_ID_UTENTE: this.notaSpesa.FK_ID_UTENTE,
				DATA: this.notaSpesa.DATA,
				IMPORTO: this.notaSpesa.IMPORTO,
				TIPO_MOVIMENTO: this.notaSpesa.TIPO_MOVIMENTO,
				DESCRIZIONE: this.notaSpesa.DESCRIZIONE,
				FK_ID_PROGETTO: this.selectedProgetto,
				FLG_ATTIVO: this.notaSpesa.FLG_ATTIVO,
				FK_ID_CATEGORIA: this.notaSpesa.FK_ID_CATEGORIA,
				FK_ID_ELABORAZIONE: this.notaSpesa.FK_ID_ELABORAZIONE,
				FLG_FATTURA: this.notaSpesa.FLG_FATTURA,
				FILE_ALLEGATO: this.notaSpesa.FILE_ALLEGATO
			};

			utils.put('theb/note_spese/update', payload, (res) => {
				this.loading = false;
				if (res.esito == 0) {
					this.$emit('saved');
					this.close();
				} else {
					this.message = res.messaggio || 'Errore nel salvataggio';
					this.messageClass = 'alert-danger';
				}
			});
		},
		close() {
			this.$emit('close');
		},
		formatData(data) {
			if (!data) return '';
			const d = new Date(data);
			return d.toLocaleDateString('it-IT');
		},
		formatImporto(importo) {
			if (!importo) return '0.00';
			return Math.abs(parseFloat(importo)).toFixed(2);
		},
		getImportoSign(nota) {
			return nota.TIPO_MOVIMENTO === 0 ? '−' : '+';
		},
		getImportoColor(nota) {
			return nota.TIPO_MOVIMENTO === 0 ? '#dc3545' : '#28a745';
		}
	},
	mounted() {
		this.loadingProgetti = true;
		utils.get('theb/progetto/lista', {}, (res) => {
			if (res.esito == 0) {
				this.arrayProgetti = res.data || [];
			}
			this.loadingProgetti = false;
		});
	}
};
</script>

<style scoped>
.modal {
	z-index: 1050;
}

.modal.show {
	background-color: rgba(0, 0, 0, 0.5);
}

@media (max-width: 575.98px) {
	.modal-footer {
		flex-direction: column-reverse;
	}
	.modal-footer > * {
		width: 100%;
		margin-left: 0 !important;
		margin-right: 0 !important;
	}
}
</style>
